<template>
  <div v-if="meta.pagination && meta.pagination.total_pages > 1">
    <nav aria-label="Page navigation">
      <ul class="pagination">
        <li class="page-item">
          <span class="page-link" aria-label="Previous" @click="changePage(1)">
            <span aria-hidden="true"
              ><i class="fa fa-angle-double-left" aria-hidden="true"
            /></span>
            <span class="sr-only">Previous</span>
          </span>
        </li>
        <li class="page-item">
          <span class="page-link" aria-label="Previous" @click="prevPage">
            <span aria-hidden="true"
              ><i class="fa fa-angle-left" aria-hidden="true"
            /></span>
            <span class="sr-only">Previous</span>
          </span>
        </li>
        <li class="page-item" v-if="meta.pagination.current_page > 1">
          <span
            class="page-link"
            @click="changePage(meta.pagination.current_page - 1)"
            >{{ meta.pagination.current_page - 1 }}</span
          >
        </li>
        <li class="page-item active">
          <span
            class="page-link"
            @click="changePage(meta.pagination.current_page)"
            >{{ meta.pagination.current_page }}</span
          >
        </li>
        <li
          class="page-item"
          v-if="meta.pagination.current_page < meta.pagination.total_pages"
        >
          <span
            class="page-link"
            @click="changePage(meta.pagination.current_page + 1)"
            >{{ meta.pagination.current_page + 1 }}</span
          >
        </li>
        <li class="page-item">
          <span class="page-link" aria-label="Next" @click="nextPage">
            <span aria-hidden="true"
              ><i class="fa fa-angle-right" aria-hidden="true"
            /></span>
            <span class="sr-only">Next</span>
          </span>
        </li>
        <li class="page-item">
          <span
            class="page-link"
            aria-label="Next"
            @click="changePage(meta.pagination.total_pages)"
          >
            <span aria-hidden="true"
              ><i class="fa fa-angle-double-right" aria-hidden="true"
            /></span>
            <span class="sr-only">Next</span>
          </span>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  props: {
    changePage: {
      type: Function,
      default: null
    },
    meta: {
      type: [Object, String, Array],
      default: null
    }
  },
  methods: {
    prevPage() {
      if (this.meta.pagination.current_page > 1) {
        this.changePage(this.meta.pagination.current_page - 1);
      }
    },
    nextPage() {
      if (
        this.meta.pagination.current_page < this.meta.pagination.total_pages
      ) {
        this.changePage(this.meta.pagination.current_page + 1);
      }
    }
  }
};
</script>
